import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const currentLang = i18n.language.split('-')[0]; // Get 'it' from 'it-IT'
  
  // Show only the opposite language flag to switch
  const showLanguage = currentLang === 'it' ? 'en' : 'it';

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => changeLanguage(showLanguage)}
      className="flex items-center gap-2 px-3 py-2 h-auto bg-white/80 backdrop-blur-sm rounded-lg border border-slate-200/50 shadow-sm hover:bg-slate-50 hover:border-slate-300 transition-all"
      title={showLanguage === 'en' ? 'Switch to English' : 'Passa all\'Italiano'}
    >
      <span className="text-2xl">
        {showLanguage === 'en' ? '🇬🇧' : '🇮🇹'}
      </span>
      <span className="text-sm font-medium text-slate-700">
        {showLanguage === 'en' ? 'EN' : 'IT'}
      </span>
    </Button>
  );
};

export default LanguageSwitcher;
